const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHappyClients(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-176"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329,34.58s-77.4-27.52-153.37,16.3S61.3,181.67,28.38,251.34s-14,140.55,44,172.86,97.43-15.32,178.79-17.64S354.44,415.87,422,369.91s79.71-154.51,26.46-234.82S329,34.58,329,34.58Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,34.58s-77.4-27.52-153.37,16.3S61.3,181.67,28.38,251.34s-14,140.55,44,172.86,97.43-15.32,178.79-17.64S354.44,415.87,422,369.91s79.71-154.51,26.46-234.82S329,34.58,329,34.58Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bookshelf-2--inject-176"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 162,
    y1: 26,
    x2: 162,
    y2: 461,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 212,
    y1: 26,
    x2: 212,
    y2: 461,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243,
    y1: 26,
    x2: 243,
    y2: 461,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287,
    y: 99,
    width: 176,
    height: 363,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.71,
    y: 99,
    width: 8.34,
    height: 363,
    style: {
      fill: "#263238",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.19,
    y: 132.72,
    width: 175.66,
    height: 4.84,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 287.53,
    y1: 143.2,
    x2: 462,
    y2: 143.2,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291,
    y: 101.63,
    width: 22,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 101.63,
    width: 2.33,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318,
    y: 101.63,
    width: 22,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 101.63,
    width: 2.33,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.04,
    y: 107.16,
    width: 18.08,
    height: 25.48,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.12,
    y: 107.16,
    width: 1.92,
    height: 25.48,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 101.63,
    width: 22,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394,
    y: 101.63,
    width: 2.33,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.33,
    y: 107.16,
    width: 18.08,
    height: 25.48,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.42,
    y: 107.16,
    width: 1.92,
    height: 25.48,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.33,
    y: 107.16,
    width: 18.08,
    height: 25.48,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.42,
    y: 107.16,
    width: 1.92,
    height: 25.48,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.19,
    y: 184.72,
    width: 175.66,
    height: 4.84,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 287.53,
    y1: 195.2,
    x2: 462,
    y2: 195.2,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.01,
    y: 151.1,
    width: 23.8,
    height: 33.53,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.81,
    y: 151.1,
    width: 2.52,
    height: 33.53,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318,
    y: 153.63,
    width: 22,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 153.63,
    width: 2.33,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 153.63,
    width: 22,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367,
    y: 153.63,
    width: 2.33,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 154.09,
    width: 21.68,
    height: 30.55,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.68,
    y: 154.09,
    width: 2.3,
    height: 30.55,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.6,
    y: 156.94,
    width: 19.65,
    height: 27.69,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.25,
    y: 156.94,
    width: 2.08,
    height: 27.69,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426,
    y: 147.37,
    width: 26.44,
    height: 37.26,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.44,
    y: 147.37,
    width: 2.8,
    height: 37.26,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.19,
    y: 236.72,
    width: 175.66,
    height: 4.84,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 287.53,
    y1: 247.2,
    x2: 462,
    y2: 247.2,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291,
    y: 205.63,
    width: 22,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 205.63,
    width: 2.33,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318,
    y: 205.63,
    width: 22,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 205.63,
    width: 2.33,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 205.63,
    width: 22,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367,
    y: 205.63,
    width: 2.33,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.51,
    y: 208.84,
    width: 19.73,
    height: 27.8,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.24,
    y: 208.84,
    width: 2.09,
    height: 27.8,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399,
    y: 205.63,
    width: 22,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421,
    y: 205.63,
    width: 2.33,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426,
    y: 205.63,
    width: 22,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448,
    y: 205.63,
    width: 2.33,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.19,
    y: 288.72,
    width: 175.66,
    height: 4.84,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 287.53,
    y1: 299.2,
    x2: 462,
    y2: 299.2,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291,
    y: 257.63,
    width: 22,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 257.63,
    width: 2.33,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318,
    y: 257.63,
    width: 22,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 257.63,
    width: 2.33,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 257.63,
    width: 22,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367,
    y: 257.63,
    width: 2.33,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 257.63,
    width: 22,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394,
    y: 257.63,
    width: 2.33,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399,
    y: 257.63,
    width: 22,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421,
    y: 257.63,
    width: 2.33,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426,
    y: 257.63,
    width: 22,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448,
    y: 257.63,
    width: 2.33,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.19,
    y: 340.72,
    width: 175.66,
    height: 4.84,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 287.53,
    y1: 351.2,
    x2: 462,
    y2: 351.2,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291,
    y: 309.63,
    width: 22,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 309.63,
    width: 2.33,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318,
    y: 309.63,
    width: 22,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 309.63,
    width: 2.33,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 309.63,
    width: 22,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367,
    y: 309.63,
    width: 2.33,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 309.63,
    width: 22,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394,
    y: 309.63,
    width: 2.33,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399,
    y: 309.63,
    width: 22,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421,
    y: 309.63,
    width: 2.33,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426,
    y: 309.63,
    width: 22,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448,
    y: 309.63,
    width: 2.33,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.19,
    y: 392.72,
    width: 175.66,
    height: 4.84,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 287.53,
    y1: 403.2,
    x2: 462,
    y2: 403.2,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291,
    y: 361.63,
    width: 22,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 361.63,
    width: 2.33,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318,
    y: 361.63,
    width: 22,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 361.63,
    width: 2.33,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 361.63,
    width: 22,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367,
    y: 361.63,
    width: 2.33,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 361.63,
    width: 22,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394,
    y: 361.63,
    width: 2.33,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399,
    y: 361.63,
    width: 22,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421,
    y: 361.63,
    width: 2.33,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426,
    y: 361.63,
    width: 22,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448,
    y: 361.63,
    width: 2.33,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.19,
    y: 444.72,
    width: 175.66,
    height: 4.84,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 287.53,
    y1: 455.2,
    x2: 462,
    y2: 455.2,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291,
    y: 413.63,
    width: 22,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 413.63,
    width: 2.33,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318,
    y: 413.63,
    width: 22,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 413.63,
    width: 2.33,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 413.63,
    width: 22,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367,
    y: 413.63,
    width: 2.33,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 413.63,
    width: 22,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394,
    y: 413.63,
    width: 2.33,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399,
    y: 413.63,
    width: 22,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421,
    y: 413.63,
    width: 2.33,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426,
    y: 413.63,
    width: 22,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448,
    y: 413.63,
    width: 2.33,
    height: 31,
    style: {
      fill: "none",
      stroke: "#676f74",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-176"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 179.88,
    y: 205,
    width: 14.24,
    height: 63.33,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.67,
    y: 179.67,
    width: 84.67,
    height: 63.33,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.12,
    y: 184.49,
    width: 71.76,
    height: 53.68,
    style: {
      fill: "#e5e5e5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.28,449.13,277.13,462h-47.2s-1.14-5.15,1.43-7.15,12-3.72,14-4.29,6-3.72,6-3.72Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.38,459.06l-.25,2.94h-47.2a13.24,13.24,0,0,1-.24-2.9C243.22,459.05,268.79,459,277.38,459.06Z",
    style: {
      fill: "#919191",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,314.69s-1.43,33.75-1.43,42.62,7.15,25.46,7.44,35.18-4.87,50.92-4.87,50.92l-21.45-.29S256,426,255.39,409.66s-7.15-55.78-8.58-68.94-4.58-27.18-4.58-27.18Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.71 440.55 279.99 449.99 257.68 448.84 257.68 438.26 281.71 440.55",
    style: {
      fill: "#919191",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,292.09s-2.58,12.87-3.72,18.59-6.87,20.89-7.15,27.46-2.58,31.47-2.58,45.2-.57,17.16-3.43,28.89-5.72,30.61-5.72,30.61a71,71,0,0,1-12.87-.86,37.28,37.28,0,0,1-13.16-4.58l-.29-5.43s-1.43-7.73-2-10,3.43-12.59,3.43-13.73-3.14-4.87-4.29-10.59-5.15-39.47-5.15-44.34-1.71-38.61-1.71-38.61-3.44-21.74-3.44-24.32,46.63-2.86,54.35-3.43S286.57,287.8,284,292.09Z",
    style: {
      fill: "#919191",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,298.38s6.29,10.3,13.73,13.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 254.7,
    y1: 336.44,
    x2: 254.25,
    y2: 338.72,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.97,
    y1: 299.53,
    x2: 255.5,
    y2: 332.39,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,340.15a119.85,119.85,0,0,1-13.16,1.14H237.37l-.28,6.29a65.6,65.6,0,0,0,14.58,1.15,113.76,113.76,0,0,0,16.31-2Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,346.73s-.57,11.15-.29,19.45-3.14,9.72-6.86,9.72-20.31,2-22.6.29-3.15-6.29-2.29-10,1.15-18.6,1.15-18.6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.68,452l-.86,10H211.63s-1.15-5.15,1.43-7.15,12-3.72,14-4.29,6-3.72,6-3.72Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.08,459.06l-.26,2.94H211.63a12.87,12.87,0,0,1-.25-2.9C224.91,459.05,250.48,459,259.08,459.06Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.55,439.12s-.58,13.16-2.87,13.73-31.46-4.29-31.75-6.58,2.58-6.58,2.86-8,.29-3.72,1.43-5.43S257.11,436.26,264.55,439.12Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.52,261.4s-4.62,1.18-5.9,2.26-3,3.93-2.45,5.1,1.57.69,2,.1a17.3,17.3,0,0,1,4.13-4.42,46.41,46.41,0,0,1,5.4-2.75A4.24,4.24,0,0,0,146.52,261.4Z",
    style: {
      fill: "#e5e5e5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.25,191.86l-19.9,45.76s-6.63,2.66-19.9,7.63-27.19,11.28-30.51,12.27-11.27,2.65-15.25,5-7.41,7.11-4.76,7.44c.93.12,1,1.08,3.34.79a5.78,5.78,0,0,0,2.56-1.28,19.61,19.61,0,0,1,5.82-3,21.79,21.79,0,0,1,8.81-.47,14.25,14.25,0,0,0,4,0,37.89,37.89,0,0,0,4.42-3.48s23.21-2,32.5-3.65,23.21-6.3,23.21-6.3l14.93-60.36Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.32,262.5s-9.62,3.31-10.28,7.29",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.9,262.5a26.5,26.5,0,0,1-4.65,3.64c-2.32,1.33-5.3.67-7.62,2s-3,2.32-5.64,2-2.66-2.65.66-3.64a18.82,18.82,0,0,0,4.31-1.66l2-2.32",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.45 208.62 116.88 209.94 107.66 268.51 189.38 269.17 183.45 208.62",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "175.56 268.51 178.19 208.62 144 249 116.88 209.94",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.41,156.79s5.43,2,13.44,9.44,14.3,26.89,15.16,37.19-5.43,41.76-5.43,49.48-2.29,40.91-3.44,41.77-37.18,3.71-53.2,2.86-16.88-7.16-18.59-13.16-2.87-21.74-.29-39.76,5.72-41.48,12.87-53.49,12-18.31,18-23.75S263.12,156.22,267.41,156.79Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.72 220.96 243.09 220.09 243.09 197.18 256.72 198.05 256.72 220.96",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.89,
    y: 193.99,
    width: 2.61,
    height: 6.96,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.82 216.12 245.99 215.36 245.99 203.47 253.82 204.23 253.82 216.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.83,192.35l20.73,46.1-37.78,17.82s-21.56.12-23.24-.17-16.48,9-17.23,9.8a1.1,1.1,0,0,0,.08,1.58s-1.87,1.76-.56,2.77l1.3,1s-.14.84,1.76,1.87,2.77.56,2.77.56a23.17,23.17,0,0,0,3.67-1.11c1.59-.68,6.42-4.54,7.26-4.39s10.25,1.5,14,1.36,6.64-3.81,6.64-3.81,32.45-.41,43.55-3.37,24.89-10.92,27.39-13.88-6.34-41.45-9.49-49.9-8.1-17.54-9.51-18.91",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.66,273.68s-.86.46-2.77-.56-1.76-1.87-1.76-1.87l-1.3-1c-1.31-1,.56-2.77.56-2.77a1.1,1.1,0,0,1-.08-1.58c.75-.82,15.54-10.09,17.23-9.8s23.24.17,23.24.17l37.78-17.82-8.72-19.4,31-13.38c3.82,14.05,9.4,40.39,7.34,42.81-2.5,3-16.29,10.92-27.39,13.88s-43.55,3.37-43.55,3.37-2.89,3.67-6.64,3.81-13.17-1.22-14-1.36-5.67,3.71-7.27,4.39A22.88,22.88,0,0,1,204.66,273.68Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 199.39,
    y1: 267.48,
    x2: 211.17,
    y2: 261.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200.49,
    y1: 270.89,
    x2: 211.55,
    y2: 263.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.3,273.64a1.11,1.11,0,0,1,.58-1.5c1-.46,9.11-6.28,9.11-6.28",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.19,164.17l4.81,3.68s-8.77,17-4.81,17.83,17.55-17.26,22.64-23.21,7.58-5.68,7.58-5.68-6.16-7-8.43-12.43-3.39-8.77-3.39-8.77Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.94,120.15s-.48,22.33.15,26.27,6.08,14.88,8.15,17.24,10.54,2.7,13.62.86,10.92-11.85,12.31-15.79a27.41,27.41,0,0,0,1.53-7.32s4.92,1.24,7.7-4.6,0-10.46-3.66-10.21l-3.13,1.51s4.29-11.13,1.59-15.42-26.65-2.15-31.58-1.37S220.94,120.15,220.94,120.15Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.72,133s3.35-2.51,6.69-.56",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.55,131.32s4.18-1.11,5,2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.24,132.66a1.46,1.46,0,1,1-1.46-1.46A1.47,1.47,0,0,1,226.24,132.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.88,133.51a1.46,1.46,0,1,1-1.46-1.46A1.46,1.46,0,0,1,242.88,133.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.22,121.37l5.62,1.49a1.44,1.44,0,0,1,1,1.89l-.14.38a1.46,1.46,0,0,1-1.83.88l-5.47-1.87a1.44,1.44,0,0,1-.89-1.87h0A1.44,1.44,0,0,1,241.22,121.37Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.8,122l0,.09a1.17,1.17,0,0,1-.63,1.57l-3.9,1.56a1.18,1.18,0,0,1-1.6-.91h0a1.18,1.18,0,0,1,.7-1.26l3.86-1.65A1.18,1.18,0,0,1,228.8,122Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.77,143.16s-2.4,5.21-9.28,4.77",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.82,127.7s-.91,13.55-1,14.65,2.87,4.16,5.13,1.82a7.62,7.62,0,0,0,2.38-4.33",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.66,127.32a7.6,7.6,0,1,0-6,12.3,6.35,6.35,0,0,0,5.46-2.56Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242.04,
    cy: 132.02,
    r: 7.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 249.67,
    y1: 130.5,
    x2: 261.5,
    y2: 126.83,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 216.17,
    y1: 131.17,
    x2: 220.67,
    y2: 130.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.66,129a4.4,4.4,0,0,1,4.87.34",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.46,99.66s9.92,7.18,7.79,14.94-8.2,22.55-8.2,22.55l-1.65.26-.56-5.64s-5.58-1.13-5.33-5.89a20.57,20.57,0,0,1,2.08-8.09S247.69,123,241,123s-10.95-7.36-12.83-4.36-5.24,5.22-12.72,2.71-19.52-18.8-12.75-24.94,20.19,1.83,24.29,2.19,6-6.69,15.31-5.48A37.35,37.35,0,0,1,258.46,99.66Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.28,
    y: 265.76,
    width: 214.12,
    height: 196.55,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.28,
    y: 265.76,
    width: 214.12,
    height: 13.23,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.65,
    y: 265.76,
    width: 67.75,
    height: 196.55,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.08,
    y: 265.76,
    width: 232.52,
    height: 7.53,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.28,
    y: 265.76,
    width: 85.31,
    height: 7.53,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bookshelf-1--inject-176"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.76,180s-.19-5.1-2.35-8.63-10-6.08-14.11-4.31a54.82,54.82,0,0,0-6.08,2.94,46.11,46.11,0,0,1,11.57,5.49A29.11,29.11,0,0,0,336.76,180Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,182.57s-4.71-4.51-5.49-10.79,5.88-16.07,5.88-16.07a69.86,69.86,0,0,1,5.29,13.13C352.65,175.9,345,182.57,345,182.57Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354,180.61s-1.18-5.88,1-10,7.84-3.73,13.53-2,7.45,1.76,7.45,1.76a84.52,84.52,0,0,1-12.36,6.86A75.6,75.6,0,0,1,354,180.61Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.05,201.74a.51.51,0,0,1-.51-.51v-28a.51.51,0,0,1,1,0v28A.51.51,0,0,1,345.05,201.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.41,201.74h-.08a.51.51,0,0,1-.43-.57c.1-.7,2.47-17.31,10.51-26.54a.51.51,0,1,1,.77.67c-7.85,9-10.25,25.84-10.27,26A.52.52,0,0,1,347.41,201.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.7,201.34h0a.5.5,0,0,1-.5-.51c0-.16.08-16.12-9.42-23.71a.51.51,0,0,1,.64-.8c9.88,7.91,9.8,23.85,9.8,24.52A.51.51,0,0,1,342.7,201.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.54,201.15l-.13,0a.51.51,0,0,1-.36-.62,32.69,32.69,0,0,1,4.59-9.58.51.51,0,0,1,.71-.11.52.52,0,0,1,.11.71,32,32,0,0,0-4.43,9.24A.51.51,0,0,1,350.54,201.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.63,193.35s-.2-5.49,2.15-6.27,4.51,1.17,6.28,2.35,3.72,2.35,3.72,5.88a66.19,66.19,0,0,1-1.37,10s-2-6.08-5.29-8.82S353.63,193.35,353.63,193.35Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.17,201.34a.48.48,0,0,1-.48-.35,18,18,0,0,0-5.13-7.6.51.51,0,0,1,.63-.79,18.68,18.68,0,0,1,5.46,8.08.5.5,0,0,1-.33.64A.39.39,0,0,1,339.17,201.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.76,195.12s.79-3.53-1.17-6.08-6.67-2-9,.78-5.69,11-5.69,11,4.71-3.72,10.2-3.72S336.76,195.12,336.76,195.12Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.39 231.4 336.74 231.4 328.92 205.52 360.21 205.52 352.39 231.4",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.83,
    y: 201.23,
    width: 31.47,
    height: 4.29,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.51,
    y: 231.18,
    width: 38.14,
    height: 77.06,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.22,
    y: 231.18,
    width: 113.74,
    height: 77.06,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.09,
    y: 236.47,
    width: 102.12,
    height: 65.96,
    style: {
      fill: "#e5e5e5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.37,
    y: 236.47,
    width: 51.84,
    height: 65.96,
    style: {
      fill: "#e5e5e5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.09,
    y: 267.26,
    width: 102.12,
    height: 4.37,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.87,
    y: 308.17,
    width: 38.14,
    height: 77.06,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.25 341.76 248.63 384.88 224.73 384.88 236.25 341.76",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.2 337.21 235.62 335.79 194.65 384.88 228.38 384.88 237.2 337.21",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.62 335.79 201.89 335.79 192.97 384.88 226.69 384.88 235.62 335.79",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 206.04,
    y1: 345.38,
    x2: 227.62,
    y2: 345.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 204.65,
    y1: 350.95,
    x2: 226.22,
    y2: 350.95,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 203.26,
    y1: 356.52,
    x2: 224.83,
    y2: 356.52,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.96,
    y: 308.17,
    width: 171.35,
    height: 77.06,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.84,
    y: 313.46,
    width: 159.74,
    height: 65.96,
    style: {
      fill: "#e5e5e5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.15,
    y: 313.46,
    width: 121.43,
    height: 65.96,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.88,
    y: 313.46,
    width: 115.69,
    height: 65.96,
    style: {
      fill: "#e5e5e5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.71,
    y: 313.46,
    width: 74.87,
    height: 65.96,
    style: {
      fill: "#e5e5e5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.01,
    y: 313.46,
    width: 45.56,
    height: 65.96,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.75,
    y: 313.46,
    width: 39.83,
    height: 65.96,
    style: {
      fill: "#e5e5e5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 437.55,
    y: 384.94,
    width: 38.14,
    height: 77.06,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.69,
    y: 384.94,
    width: 256.3,
    height: 77.06,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.57,
    y: 390.23,
    width: 244.69,
    height: 65.96,
    style: {
      fill: "#e5e5e5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.24,
    y: 390.23,
    width: 176.02,
    height: 65.96,
    style: {
      fill: "#e5e5e5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.68,
    y: 390.23,
    width: 155.58,
    height: 65.96,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.41,
    y: 390.23,
    width: 149.85,
    height: 65.96,
    style: {
      fill: "#e5e5e5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.4,
    y: 390.23,
    width: 111.86,
    height: 65.96,
    style: {
      fill: "#e5e5e5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.82,
    y: 390.23,
    width: 77.43,
    height: 65.96,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.28,
    y: 390.23,
    width: 70.98,
    height: 65.96,
    style: {
      fill: "#e5e5e5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.87,
    y: 390.23,
    width: 33.39,
    height: 65.96,
    style: {
      fill: "#e5e5e5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "433.19 264.71 445.57 307.82 421.67 307.82 433.19 264.71",
    style: {
      fill: "#787878",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.14 260.16 432.56 258.73 391.59 307.82 425.32 307.82 434.14 260.16",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.56 258.73 398.83 258.73 389.9 307.82 423.63 307.82 432.56 258.73",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.31,
    y1: 266.41,
    x2: 424.88,
    y2: 266.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 401.92,
    y1: 271.97,
    x2: 423.49,
    y2: 271.97,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400.53,
    y1: 277.54,
    x2: 422.1,
    y2: 277.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.43 335.68 353.81 378.8 329.91 378.8 341.43 335.68",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.38 331.13 340.8 329.7 299.83 378.8 333.56 378.8 342.38 331.13",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.8 329.7 307.07 329.7 298.14 378.8 331.87 378.8 340.8 329.7",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.16,357.59l.1-.09.45.57,5.27-4.39-1.06-1.33-5.13,4.26-.55-1.48-1,1.26-3.15-3.95-1.61,1.33,3.44,4.32-2,2.56-3.41,2.84,1.06,1.33,1.75-1.44-1.49,7.31h6.48l1.52-7.52,1.36,1.71,1.61-1.34-2.68-3.37Zm1.71,4.93.43-.36.53.66-.44.36Zm.28.87-.44.36-.52-.66.43-.36Zm-.45-1.07-.52-.66.44-.36.52.66Zm-6.7-1.39h.73l-.44.36h-.23l-.2-.25Zm1.11,0,.27.34h-.68Zm-1.38.44-.09.44-.52.44-.29-.36.79-.66Zm-.17.85-.1.46-.18-.23Zm-.69.23-.79.66-.29-.36.79-.66Zm.16.21.29.36-.79.66-.29-.37Zm2.61-1.57-.14-.18h.36Zm3.29-.18-.28.23-.19-.23Zm.32.08.23.28h-.58Zm1,.28h-.33l-.29-.36h.72l.13.17Zm-.71-4,.8-.66.29.36-.8.67Zm3.12-2.59.79-.66.29.36-.79.66Zm0,.56-.79.66-.29-.36.8-.66Zm-.2-.77-.29-.36.79-.66.29.37Zm-.25.21-.79.66-.29-.37.79-.65Zm-1,.86-.8.66-.28-.36.79-.66Zm.16.2.29.37-.79.65-.29-.36ZM316,354.2l-.29-.36.62-.52.29.36Zm.16-1.08-.61.51-.29-.36.62-.51Zm-4.26,2.94.29.36-.8.67-.29-.36Zm-.76,1.23,0,0-.06-.16Zm-2.41-.18-.48-.6.44-.36.4.5Zm-2-2.53-.53-.66.44-.36.52.66Zm.59-.16.53.66-.44.36-.52-.65Zm-.84.37-.44.36-.52-.66.44-.36Zm.16.2.53.66-.44.36-.52-.66Zm.69.86.52.66-.43.36-.53-.66Zm.25-.2.43-.36.53.65-.44.37Zm-1.11-2.29-.43.36-.41-.51.43-.37Zm-1.09.05.41.51-.43.37-.41-.52Zm2.73,4.34-.53-.67.44-.36.52.65-.05.06ZM303.54,363l.29.36-.62.52-.28-.36Zm-.16,1.08.62-.51.28.36-.61.52Zm4.45-2.76.44-.36h1.78l.29.36Zm4.24.75.39.48-.44.37-.09-.13Zm.8,1.91.44-.36.41.52-.44.36Zm1.09-.05-.41-.51L314,363l.41.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.83,352.92l.14-.12.62.77,7.15-5.95-1.45-1.81-7,5.78-.76-2-1.33,1.72L321,345.93l-2.18,1.81,4.66,5.86-2.71,3.48-4.63,3.84,1.45,1.81,2.36-2-2,9.92h8.78l2.07-10.2,1.84,2.31,2.18-1.81-3.63-4.57Zm2.32,6.69.59-.49.71.9-.59.49Zm.38,1.17-.59.49-.71-.89.59-.49Zm-.6-1.44-.71-.9.59-.49.71.9Zm-9.09-1.89h1l-.59.49h-.31l-.27-.33Zm1.5,0,.37.46h-.93Zm-1.87.59-.12.61-.71.59-.39-.49,1.07-.9Zm-.24,1.16-.12.63-.25-.32Zm-.93.31-1.07.9-.39-.5,1.07-.89Zm.23.28.39.49-1.08.89-.39-.49Zm3.53-2.12-.19-.25h.49Zm4.46-.25-.38.32-.25-.32Zm.43.1.32.39h-.79Zm1.32.39h-.45l-.39-.49h1l.18.23Zm-1-5.42,1.09-.91.39.49-1.09.91Zm4.23-3.52,1.08-.89.39.49-1.07.89Zm.06.77-1.07.89-.39-.49,1.07-.89Zm-.28-1-.39-.49,1.07-.89.4.49ZM332,349l-1.07.89-.39-.49,1.07-.89Zm-1.41,1.17-1.07.89-.39-.49,1.07-.89Zm.22.27.4.5-1.08.89-.39-.49Zm3.54-2.12-.39-.49.84-.7.39.49Zm.23-1.47-.84.7-.39-.49.84-.7Zm-5.78,4,.39.49-1.09.9-.39-.49Zm-1,1.67-.05,0-.08-.21Zm-3.26-.25-.65-.81.59-.49.54.68Zm-2.74-3.43L321,348l.59-.49.71.89Zm.82-.21.71.89-.59.49-.72-.89Zm-1.15.49-.59.49-.71-.89.59-.49Zm.22.28.71.89-.59.49-.71-.89Zm.93,1.16.71.9-.59.49-.71-.89Zm.34-.27.59-.49.71.89-.59.49Zm-1.5-3.11-.59.49-.55-.69.59-.5Zm-1.48.07.56.7-.59.49-.56-.7Zm3.71,5.88-.73-.91.59-.49.71.89-.07.09Zm-6.13,7.09.39.49-.84.7-.39-.49Zm-.23,1.47.84-.7.39.49-.84.7Zm6-3.75.59-.49h2.43l.39.49Zm5.75,1,.53.65-.59.5-.14-.17Zm1.09,2.59.59-.49.56.7-.59.49Zm1.48-.07-.56-.7.59-.49.56.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.44,341.9c-.06-.74-1.07-1.34-2.39-1.44a3.4,3.4,0,0,0,.08-.63c0-2.23-2.16-4-4.83-4a4.65,4.65,0,0,0-4.74,3.34,4.38,4.38,0,0,0-.51,0,2.73,2.73,0,0,0-2.83,2,2.68,2.68,0,0,0-3.53,0,4.62,4.62,0,0,0-1.4-.2c-1.14,0-2.07.33-2.07.74a.36.36,0,0,0,.13.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.67,345.2c0-.33-.47-.59-1.05-.64a2.48,2.48,0,0,0,0-.27,2,2,0,0,0-2.12-1.78,2.05,2.05,0,0,0-2.09,1.47l-.22,0a1.21,1.21,0,0,0-1.25.88,1.17,1.17,0,0,0-1.55,0,2.17,2.17,0,0,0-.62-.08c-.5,0-.91.14-.91.32a.15.15,0,0,0,.06.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.9 412.74 351.28 455.86 327.37 455.86 338.9 412.74",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.84 408.19 338.26 406.76 297.29 455.86 331.02 455.86 339.84 408.19",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.26 406.76 304.54 406.76 295.61 455.86 329.34 455.86 338.26 406.76",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.89 419.35 307.05 419.35 301 452.6 323.85 452.6 329.89 419.35",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.7 411.98 307.76 417.12 330.61 417.12 331.54 411.98 308.7 411.98",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.39 412.74 277.77 455.86 253.86 455.86 265.39 412.74",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.33 408.19 264.75 406.76 223.78 455.86 257.51 455.86 266.33 408.19",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.75 406.76 231.03 406.76 222.1 455.86 255.83 455.86 264.75 406.76",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.31,424.38a11.32,11.32,0,0,1-5.4,6.8c-4.4,2.4-11.2-1-16.61,3.81s-5.6,15,5.81,16.2,13.8-7.4,13.8-7.4,5.21,1,5-.6-3.61-2.8-3.61-2.8a18.63,18.63,0,0,0,2.61-8.21c.13-4.3,0-7.2,0-7.2s2.8.6,3.8,0,3-6.2,3-6.2-3.4,2.4-5,2.4-5.81-3.4-5.81-3.4S249.11,424.38,252.31,424.38Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.99 411.64 232.06 416.78 254.9 416.78 255.84 411.64 232.99 411.64",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.64 419.08 230.71 424.21 244.43 424.21 245.36 419.08 231.64 419.08",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.94 412.74 427.32 455.86 403.42 455.86 414.94 412.74",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "415.89 408.19 414.31 406.76 373.34 455.86 407.06 455.86 415.89 408.19",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.31 406.76 380.58 406.76 371.65 455.86 405.38 455.86 414.31 406.76",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.5,421.13a4.31,4.31,0,1,1-4.29-3.89A4.1,4.1,0,0,1,389.5,421.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.7,428.28a4.32,4.32,0,1,1-4.29-3.88A4.1,4.1,0,0,1,398.7,428.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,422.39a3.59,3.59,0,1,1-3.58-3.24A3.42,3.42,0,0,1,405,422.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 385.93,
    cy: 440.28,
    rx: 8.07,
    ry: 7.3,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.77,
    y: 327.99,
    width: 4.63,
    height: 51.5,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.16,
    y: 327.99,
    width: 25.29,
    height: 51.5,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.01,
    y: 327.99,
    width: 4.63,
    height: 51.5,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.41,
    y: 327.99,
    width: 25.29,
    height: 51.5,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.26,
    y: 327.99,
    width: 4.63,
    height: 51.5,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.65,
    y: 327.99,
    width: 22.2,
    height: 51.5,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.5,
    y: 327.99,
    width: 4.63,
    height: 51.5,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.89,
    y: 327.99,
    width: 17.27,
    height: 51.5,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.5,
    y: 327.99,
    width: 4.63,
    height: 51.5,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.9,
    y: 327.99,
    width: 25.29,
    height: 51.5,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.75,
    y: 327.99,
    width: 4.63,
    height: 51.5,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.14,
    y: 327.99,
    width: 25.29,
    height: 51.5,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.99,
    y: 327.99,
    width: 4.63,
    height: 51.5,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.38,
    y: 327.99,
    width: 22.2,
    height: 51.5,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.23,
    y: 327.99,
    width: 4.63,
    height: 51.5,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.63,
    y: 327.99,
    width: 20.05,
    height: 51.5,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.32,
    y: 276.53,
    width: 16.65,
    height: 25.73,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.77,
    y: 276.53,
    width: 16.65,
    height: 25.73,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.43,
    y: 292.04,
    width: 34.81,
    height: 10.22,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.19,
    y: 288.14,
    width: 36.06,
    height: 7.19,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.38,
    y: 292.04,
    width: 21.19,
    height: 10.22,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.38,
    y: 288.14,
    width: 22.98,
    height: 7.19,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.33,
    y: 263.34,
    width: 59.96,
    height: 3.93,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.88,
    y: 263.34,
    width: 25.9,
    height: 3.93,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.33,
    y: 259.33,
    width: 59.96,
    height: 3.93,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.88,
    y: 259.33,
    width: 25.9,
    height: 3.93,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.33,
    y: 255.31,
    width: 59.96,
    height: 3.93,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.88,
    y: 255.31,
    width: 25.9,
    height: 3.93,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.33,
    y: 251.3,
    width: 59.96,
    height: 3.93,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.88,
    y: 251.3,
    width: 25.9,
    height: 3.93,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.33,
    y: 247.28,
    width: 59.96,
    height: 3.93,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.88,
    y: 247.28,
    width: 25.9,
    height: 3.93,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--characters-1--inject-176"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.76,349.28s2.93,14.89,2.93,20.47S56,385.43,56,397.4,59.42,441,59.42,441l12.76.53s3.72-38.81,7.71-47.85,5.58-27.92,5.58-33.24A46.58,46.58,0,0,1,87.33,349Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.57,431.16H74.84l-.27,16.49s12.23,7.71,15.16,8.77,4.52,3.46,4.25,4.25S92.39,462,92.39,462H55.7a14.65,14.65,0,0,1-.8-6.64A33.4,33.4,0,0,1,56.76,449Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.61,349.28s2.92,14.89,2.92,20.47-3.72,15.68-3.72,27.65S66.27,441,66.27,441l12.76.53s3.72-38.81,7.71-47.85,5.58-27.92,5.58-33.24A46.58,46.58,0,0,1,94.18,349Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.52,227.51s8.24,54.51,11.17,64.61S120,346.35,120,346.35a99,99,0,0,1-32.7,8c-18.87,1.33-43.33-.27-50.51-3.46s-12.23-5.31-12.23-5.31l7.71-39.35s16.75-47.06,16.75-57.69S48,227,54.11,219s13.29-11.7,18.34-10.11S94.52,227.51,94.52,227.51Z",
    style: {
      fill: "#ababab"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,311.82c-.08-.32-.17-.64-.25-1-1.77.44-3.53.86-5.27,1.23l2.39-4.92,2.78,3.3c-.21-.77-.41-1.53-.61-2.27l-1.57-1.88c.33-.07.67-.16,1-.25-.09-.32-.17-.64-.26-1-34.68,8.37-62.24,3.59-76.4-.38-.33.95-.52,1.48-.52,1.48l-.13.66,2.2,4.4c-1-.27-2-.55-2.9-.81l-.19,1A142.58,142.58,0,0,0,71,316.86,163.91,163.91,0,0,0,111,311.82Zm-4-5.16-2.45,5-4.15-3.7Q103.68,307.41,107,306.66Zm-3.14,5.78c-3,.62-5.93,1.14-8.81,1.58l4.68-5.26Zm-5.07-4.13-4.8,5.4-3.19-4.2Q94.74,309,98.81,308.31Zm-5.61,6c-3.31.46-6.52.81-9.65,1.06L90,310Zm-4.48-4.55-6.21,5.18-5.31-4.31C80.9,310.48,84.75,310.19,88.72,309.75Zm-56-4c2.33.65,5,1.32,8,1.95l-5.35,3.4Zm3.5,6,4.76-3,3.53,4.81C41.48,313,38.71,312.36,36.24,311.75Zm5.37-3.89c3,.61,6.34,1.18,10,1.65l-5.85,3.95Zm5.21,6.06,5.35-3.61,4.92,4.92C53.41,314.89,50,314.44,46.82,313.92ZM53,309.68c3,.36,6.17.64,9.52.83L58,314.7Zm5.77,5.69,4.45-4.14,5.41,4.61C65.14,315.79,61.85,315.62,58.73,315.37ZM64,310.58c2.28.1,4.63.17,7.06.17,1.14,0,2.3,0,3.48-.05l-5.24,4.4Zm11.93.27,5.74,4.65c-4.08.28-8,.38-11.72.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.16,335.25c-.15-.58-.31-1.17-.46-1.77l-2.82-3.43,1.79-.51c-.09-.32-.17-.64-.25-1-.81.22-1.62.46-2.42.67a.38.38,0,0,0-.15,0,.83.83,0,0,0-.16.09c-40.92,10.78-72.45,3.08-84.71-1l-.2,1c1.15.38,2.45.79,3.92,1.21L27,334.11l-.13,0-.2,1a.48.48,0,0,0,.47.11c7.56,2.57,23,6.73,43.9,6.73A165.3,165.3,0,0,0,117.16,335.25Zm-3.94-4.42,3,3.64c-1.38.4-2.76.78-4.12,1.13Zm-.94-.36-1,4.26-2.8-3.32C109.74,331.11,111,330.8,112.28,330.47Zm-1.34,5.42c-1.83.47-3.65.89-5.45,1.29l2.39-4.93ZM107,331.74l-2.45,5.06-4.15-3.7C102.59,332.7,104.79,332.24,107,331.74Zm-3.14,5.78c-3,.62-5.93,1.15-8.81,1.58l4.68-5.26Zm-5.07-4.13-4.8,5.4-3.19-4.2Q94.74,334.1,98.81,333.39Zm-5.61,6c-3.31.46-6.52.81-9.65,1.06L90,335.1Zm-4.48-4.55L82.51,340l-5.31-4.3C80.9,335.56,84.75,335.27,88.72,334.83Zm-60.6-.33L32,331.56l2.39,4.79C31.94,335.71,29.85,335.07,28.12,334.5Zm4.62-3.67c2.33.64,5,1.31,8,1.94l-5.35,3.4Zm3.5,6,4.76-3,3.53,4.81C41.48,338.05,38.71,337.45,36.24,336.83Zm5.37-3.89c3,.62,6.34,1.18,10,1.65l-5.85,4ZM46.82,339l5.35-3.61,4.92,4.92C53.41,340,50,339.52,46.82,339ZM53,334.76c3,.36,6.17.65,9.52.83L58,339.78Zm5.77,5.69,4.45-4.14,5.41,4.62C65.14,340.87,61.85,340.7,58.73,340.45ZM64,335.66q3.42.16,7.06.17c1.14,0,2.3,0,3.48,0l-5.24,4.39Zm11.93.27,5.74,4.65c-4.08.28-8,.38-11.72.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.33,343.6l-.25-1c-38.61,13.5-82.13,3.36-93.93.14l-.2,1a200,200,0,0,0,50.26,6.7C89.29,350.45,104.66,348.71,119.33,343.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.69,340l-.19,1a200.15,200.15,0,0,0,49.71,6.55c13.86,0,29-1.69,43.42-6.61-.08-.31-.16-.64-.25-1C80.52,352.89,38.16,343.34,25.69,340Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,323.2c-.09-.32-.17-.64-.25-1-33.88,11.3-73,3.88-84.82,1.17l-.19,1a202.93,202.93,0,0,0,43.54,4.92C85.61,329.31,100.24,327.79,114,323.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.47,321.15c-.08-.32-.17-.64-.25-1-33.37,10.93-71.62,3.86-83.86,1.09l-.19,1a203,203,0,0,0,43.12,4.83C85.44,327.09,99.86,325.6,113.47,321.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.52,227.51s8.24,54.51,11.17,64.61S120,346.35,120,346.35a99,99,0,0,1-32.7,8c-18.87,1.33-43.33-.27-50.51-3.46s-12.23-5.31-12.23-5.31l7.71-39.35s16.75-47.06,16.75-57.69S48,227,54.11,219s13.29-11.7,18.34-10.11S94.52,227.51,94.52,227.51Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.42,431.16H81.69l-.27,16.49s12.23,7.71,15.16,8.77,4.52,3.46,4.25,4.25S99.24,462,99.24,462H62.55a14.65,14.65,0,0,1-.8-6.64A33.4,33.4,0,0,1,63.61,449Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.48,204.12s-14.62,10.37-18.08,21.8-4.52,32.7-5.32,37.49-13.29,48.91-13.29,48.91,10.37,7.18,28.71,9,38.55-2.66,39.35-2.66S89.2,227,89.47,226.19s-14.89-18.35-17.55-20.74S64.48,204.12,64.48,204.12Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.29,186.48s.36,9.89,2.19,13.19,1.47,6.59-3.29,5.49-11-11-11.72-16.85S94.36,179.52,97.29,186.48Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,217.16l8.57,72.09,15.58-1.83L94.88,216.84S91.2,212.14,89,217.16Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.47,155.74a54.69,54.69,0,0,1,2.94,6.49c.87,2.63.72,7.51,1,8.31s4.19,5.51,4.21,6.46-3.55,2.82-3.55,2.82-.94,6.51-1.62,9.26-.56,4.29-4.17,4.23-8.52-1.49-14.64-4.66-10.67-7.79-11.85-14.1S85,156,87.41,154.36,97.47,155.74,97.47,155.74Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.05,170.68c-.06,1.24-.52,2.23-1,2.21s-.88-1.06-.82-2.3.53-2.24,1-2.22S99.11,169.43,99.05,170.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.74,167.65s1.79-4.58,4.58-3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.11,182.17s-3.38,1.39-5.17-1.39",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.26,192.74S98.51,200.82,98,204.48s-1.27,14.33-5.36,14.87S57.47,208,55.14,207.25s1.89-11.43,4.23-14.12S67.26,192.74,67.26,192.74Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.68,164.61s3.48,23,7.58,32.25,8.34,11.8,6.78,13.6-10.56-4-10.56-4,7.68,10.92,2.58,13.89S72,216.94,69.25,214.6l-2.69-2.34s-.86,7-9.74,11.22-21.12-3.06-13.14-13,11.3-21.36,9.89-28.25S75.29,156.86,83.68,164.61Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.62,240.27c2,4.5,6.43,8.58,9.79,12.12,5.36,5.65,11.74,10,17.34,15.36,1,1,12.06,10.57,13.38,10,0,0,11-5,18.75-12.14s27-29.22,27-29.22c4.8-1.25,12.46-7.71,12.46-7.71l7.12-.94a.92.92,0,0,0-.19-1.82l-6.61.52,9-4.69a.89.89,0,0,0,.38-1.2.9.9,0,0,0-1-.44l-9.64,2.5,8.19-4.49a1,1,0,0,0-1-1.81l-9.4,4.7,4.66-4,1.56-1.95a.76.76,0,0,0-1-1.08l-1.86,1.38c-3.39,2.57-11.51,8.75-12.27,9.76-1,1.28-5.83,6.82-5.83,6.82s-8.27,6.61-19.3,14.33a128,128,0,0,1-16.29,10.09c-3.36-4.23-13.46-17.21-17.44-25.16a27.29,27.29,0,0,0-14.07-12.79",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,220.09l-9.64,2.5,8.19-4.49a1,1,0,0,0-1-1.81l-9.4,4.7,4.66-4,1.56-1.95a.76.76,0,0,0-1-1.08l-1.86,1.38c-3.39,2.57-11.51,8.75-12.27,9.76-1,1.28-5.83,6.82-5.83,6.82s-8.27,6.61-19.3,14.33c-4.25,3-7.69,5.18-10.33,6.77l6.73,13.78c.47-.41.94-.82,1.4-1.25,7.72-7.16,27-29.22,27-29.22,4.8-1.25,12.46-7.71,12.46-7.71l7.12-.94a.92.92,0,0,0-.19-1.82l-6.61.52,9-4.69a.89.89,0,0,0,.38-1.2A.9.9,0,0,0,166,220.09Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.57,182.25s-6.75,1.06-10.4-2.89,2.07-8.92,7.92-19.11,9.64-19.81,21-22.21,25,6.91,28.06,9.4,3.11,4.75,1.64,5.36c0,0-36.07,14.34-47.88,31",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.23,
    y1: 167.05,
    x2: 53.23,
    y2: 174.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.56,185.7S69,172.14,83.7,166.05,104,159.39,104,157.37s-2.18-4.57-2.18-4.57-23.89,9-33.34,16.09S48,181.37,53.56,185.7Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-176"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 462,
    x2: 488,
    y2: 462,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyClients);
export default __webpack_public_path__ + "static/media/happyClients.5fe5d6db91ea1dde7c4ba1a6dde99c5b.svg";
export { ForwardRef as ReactComponent };